import type { RouteObject } from "react-router";
import { MarketingLayout } from "@/components/marketing/layout";
import Home from "@/pages/marketing/home";
import { LandingPage, LANDINGS } from "@/pages/marketing/landing";
import { FEATURES as FLAGS } from "@markfeed/shared";
import { About, Contact, FeaturesIndex, Pricing } from "@/pages/marketing/pages";
import { Blog, BlogPost, POSTS } from "@/pages/marketing/blog";
import { Privacy, RefundPolicy, Terms } from "@/pages/marketing/legal";

/** Marketing routes are eagerly imported so they can be prerendered to static HTML for SEO. */
export const marketingRoutes: RouteObject[] = [
  {
    element: <MarketingLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/features", element: <FeaturesIndex /> },
      { path: "/features/website-feedback", element: <LandingPage c={LANDINGS["website-feedback"]!} /> },
      { path: "/features/client-feedback", element: <LandingPage c={LANDINGS["client-feedback"]!} /> },
      ...(FLAGS.mockups ? [{ path: "/features/mockup-feedback", element: <LandingPage c={LANDINGS["mockup-feedback"]!} /> }] : []),
      { path: "/features/task-management", element: <LandingPage c={LANDINGS["task-management"]!} /> },
      { path: "/for/agencies", element: <LandingPage c={LANDINGS.agencies!} /> },
      { path: "/for/freelancers", element: <LandingPage c={LANDINGS.freelancers!} /> },
      { path: "/for/startups", element: <LandingPage c={LANDINGS.startups!} /> },
      { path: "/pricing", element: <Pricing /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/blog", element: <Blog /> },
      ...POSTS.map((p) => ({ path: `/blog/${p.slug}`, element: <BlogPost post={p} /> })),
      { path: "/terms", element: <Terms /> },
      { path: "/privacy", element: <Privacy /> },
      { path: "/refund-policy", element: <RefundPolicy /> },
    ],
  },
];
